/**
 * The design kit's shared constants (kit.jsx:5, 24-32): the two font stacks by
 * token and the soft tone table every V2 tag, pill and state reads.
 * Each tone is [background, ink, solid].
 */
export const HEAD = 'var(--font-head)';
export const BODY = 'var(--font-body)';

export const TONES = {
  neutral: ['var(--status-neutral-soft)', 'var(--status-neutral-on-soft)', 'var(--status-neutral)'],
  good: ['var(--status-on-track-soft)', 'var(--status-on-track-on-soft)', 'var(--status-on-track)'],
  bad: ['var(--status-off-track-soft)', 'var(--status-off-track-on-soft)', 'var(--status-off-track)'],
  warn: ['var(--status-warning-soft)', 'var(--status-warning-on-soft)', 'var(--status-warning)'],
  indigo: ['var(--indigo-soft)', 'var(--indigo-on-soft)', 'var(--indigo)'],
  paprika: ['var(--paprika-soft)', 'var(--paprika-on-soft)', 'var(--paprika)'],
  ghost: ['transparent', 'var(--ink-ghost)', 'var(--ink-ghost)'],
} as const;

export type V2Tone = keyof typeof TONES;
